import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from '../components/navbar';
import AuthModal from '../components/AuthModal';

const Demo = ({ onProfileClick, onBillingClick, onSeatsUpdate }) => {
  const location = useLocation();
  const [showAuthModal, setShowAuthModal] = useState(location.state?.openLogin || false);

  React.useEffect(() => {
    if (location.state?.openLogin) {
      setShowAuthModal(true);
    }
  }, [location.state]);

  return (
    <div className="App">
      <NavBar 
        onSignInClick={() => setShowAuthModal(true)} 
        onProfileClick={onProfileClick} 
        onBillingClick={onBillingClick} 
        onSeatsUpdate={onSeatsUpdate} 
      />
      <AuthModal showAuthModal={showAuthModal} setShowAuthModal={setShowAuthModal} />
      
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '40px 20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        {/* Header Section */}
        <div style={{
          textAlign: 'center',
          marginBottom: '20px'
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#1e293b',
            marginBottom: '16px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            SmartClose Demo
          </h1>
          
          <p style={{
            fontSize: '1.2rem',
            color: '#64748b',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            See how SmartClose revolutionizes your real estate closings with AI-powered automation
          </p>
        </div>

        {/* Video Section */}
        <div style={{
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          borderRadius: '20px',
          padding: '40px',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(226, 232, 240, 0.8)'
        }}>
          <div style={{
            position: 'relative',
            paddingBottom: '56.25%', // 16:9 aspect ratio
            height: 0,
            overflow: 'hidden',
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)'
          }}>
            <iframe
              src="https://www.youtube.com/embed/pmdhBacuV4M"
              title="SmartClose Demo Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                borderRadius: '12px'
              }}
            />
          </div>
        </div>

        {/* Features Highlight */}
        <div style={{
          marginTop: '30px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '30px'
        }}>
          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
            border: '1px solid #e2e8f0',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '2.5rem',
              marginBottom: '12px'
            }}>📧</div>
            <h3 style={{
              fontSize: '1.3rem',
              fontWeight: '600',
              color: '#1e293b',
              marginBottom: '8px'
            }}>Email Processing</h3>
            <p style={{
              color: '#64748b',
              lineHeight: '1.5'
            }}>
              Send documents via email and watch AI extract key information automatically
            </p>
          </div>

          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
            border: '1px solid #e2e8f0',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '2.5rem',
              marginBottom: '12px'
            }}>🤖</div>
            <h3 style={{
              fontSize: '1.3rem',
              fontWeight: '600',
              color: '#1e293b',
              marginBottom: '8px'
            }}>AI Analysis</h3>
            <p style={{
              color: '#64748b',
              lineHeight: '1.5'
            }}>
              Advanced AI recognizes properties, clients, and timelines from your documents
            </p>
          </div>

          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
            border: '1px solid #e2e8f0',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '2.5rem',
              marginBottom: '12px'
            }}>📅</div>
            <h3 style={{
              fontSize: '1.3rem',
              fontWeight: '600',
              color: '#1e293b',
              marginBottom: '8px'
            }}>Calendar Sync</h3>
            <p style={{
              color: '#64748b',
              lineHeight: '1.5'
            }}>
              Automatic tasks and events sync to Google, Outlook, and Apple calendars
            </p>
          </div>
        </div>

        {/* Call to Action */}
        <div style={{
          textAlign: 'center',
          marginTop: '30px',
          padding: '20px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '20px',
          color: 'white'
        }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '16px'
          }}>
            Ready to Transform Your Workflow?
          </h2>
          <p style={{
            fontSize: '1.1rem',
            marginBottom: '30px',
            opacity: 0.9
          }}>
            Join thousands of real estate professionals using SmartClose
          </p>
          <button
            onClick={() => window.location.href = '/signup'}
            style={{
              background: 'white',
              color: '#667eea',
              padding: '15px 30px',
              borderRadius: '25px',
              border: 'none',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 20px rgba(255, 255, 255, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 25px rgba(255, 255, 255, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 20px rgba(255, 255, 255, 0.3)';
            }}
          >
            Get Started Free
          </button>
        </div>
      </div>
    </div>
  );
};

export default Demo;